import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { useAuthStore } from "@/stores/authStore";
import { LandingPage } from "@/pages/LandingPage";
import { WizardPage } from "@/pages/WizardPage";
import { ProjectsPage } from "@/pages/ProjectsPage";
import { UserGuidePage } from "@/pages/UserGuidePage";
import { ScanPage } from "@/pages/ScanPage";
import { EmailVerificationPage } from "@/components/EmailVerification";
import { HelpFloatingButton } from "@/components/HelpFloatingButton";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";
import DemoPage from "@/pages/DemoPage";

function App() {
  const initialize = useAuthStore((state) => state.initialize);

  useEffect(() => {
    initialize();
  }, [initialize]);

  return (
    <div className="App min-h-screen bg-[#050505]">
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/wizard" element={<WizardPage />} />
          <Route path="/wizard/:projectId" element={<WizardPage />} />
          <Route path="/projects" element={<ProjectsPage />} />
          <Route path="/scan" element={<ScanPage />} />
          <Route path="/upload-scan" element={<ScanPage />} />
          <Route path="/guide" element={<UserGuidePage />} />
          <Route path="/user-guide" element={<UserGuidePage />} />
          <Route path="/verify-email" element={<EmailVerificationPage />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/demo" element={<DemoPage />} />
        </Routes>
        <HelpFloatingButton />
      </BrowserRouter>
      <Toaster position="bottom-right" richColors />
    </div>
  );
}

export default App;
